<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="contents"><a id="page_vii"></a>Contents</h2>
<p class="toc-entry"><a href="#/xhtml/frontmatter01">List of Illustrations</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02">Foreword</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter03">Acknowledgments</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01">1. “One great honored name,” 1872–1889</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter02">2. “A thunder-bolt out of a clear sky,” 1890–1896</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter03" title="Link target outside of Sample">3. “An unholy interest in reforming others,” 1897–1900</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4. “Our hope lies in the children,” 1901–1904</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5. “Whatever a woman can do . . . in the long run<br/>she will do,” 1905–1907</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6. “Educational advance and school suffrage for women<br/>go hand in hand,” 1908–1911</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7. “Among the most brilliant advocates of votes for women<br/>in this country,” 1912–1913</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8. “An able speaker, a brilliant woman,” 1914–1915</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9. “I cannot keep her from doing more than she ought to do,”<br/>1916–1918</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10. Kentucky’s “most distinguished woman citizen,” 1919–1920</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Epilogue: “She belonged to Kentucky”</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">Appendix: Selections from Articles and Speeches<br/>of Madeline McDowell Breckinridge</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter03" title="Link target outside of Sample">Notes</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter04" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter05" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4decff3b